<template>
  <div>
    <Header>Calendars</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="flex flex-col">
        <div class="flex justify-center">
          <div class="w-1/2 rounded-md bg-gray-100 shadow-sm p-2">
            <div class="flex flex-col gap-2">
              <a class="block text-center rounded-md bg-gray-200 p-2 text-gray-800 hover:text-blue-800 hover:bg-gray-300 visited:text-purple-800"
                href="https://calendar.google.com/calendar/render?cid=c_91dbe19c54afa190629989bae6d9c533814b7c58e25e982d9744011abbf80789@group.calendar.google.com">
                Add Calendar to Your Google Calendars Link
              </a>
              <a class="block text-center rounded-md bg-gray-200 p-2 text-gray-800 hover:text-blue-800 hover:bg-gray-300 visited:text-purple-800"
                href="https://docs.google.com/spreadsheets/d/1Z8wX4jHDog-RWapqQOy5U3cO7cFDqf9D31i7Mbt2X6M/edit?usp=sharing">
                Links to District Calendars & District ID / Building Code Reference
              </a>
            </div>
          </div>
        </div>
        <div>
          <div class="h-screen w-full">
            <iframe src="https://calendar.google.com/calendar/embed?src=c_d66bb86ab17b705b7f1a184dcfea2e3c188c3a578ded8ca975fdf97296276058%40group.calendar.google.com&ctz=America%2FChicago"
              frameborder="0"
              scrolling="no"
              class="mx-auto"
              style="position: relative; height: 90%; width: 90%"
            ></iframe>
          </div>
        </div>
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Main from '../components/Main.vue'
import Header from '../components/Header.vue'

export default {
  components: {
    Main,
    Header,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
